var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "feather",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2929 14.7071C13.6834 15.0976 14.3166 15.0976 14.7071 14.7071C15.0977 14.3166 15.0977 13.6834 14.7071 13.2929L13.2929 14.7071ZM11.8071 10.3929C11.4166 10.0024 10.7834 10.0024 10.3929 10.3929C10.0024 10.7834 10.0024 11.4166 10.3929 11.8071L11.8071 10.3929ZM11.6667 7.33333C11.6667 9.72657 9.72657 11.6667 7.33333 11.6667V13.6667C10.8311 13.6667 13.6667 10.8311 13.6667 7.33333H11.6667ZM7.33333 11.6667C4.9401 11.6667 3 9.72657 3 7.33333H1C1 10.8311 3.83553 13.6667 7.33333 13.6667V11.6667ZM3 7.33333C3 4.9401 4.9401 3 7.33333 3V1C3.83553 1 1 3.83553 1 7.33333H3ZM7.33333 3C9.72657 3 11.6667 4.9401 11.6667 7.33333H13.6667C13.6667 3.83553 10.8311 1 7.33333 1V3ZM14.7071 13.2929L11.8071 10.3929L10.3929 11.8071L13.2929 14.7071L14.7071 13.2929Z",
    fill: "#26282C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.67b064ca.svg";
export { ForwardRef as ReactComponent };